import React, { useState, useEffect } from 'react';
import './App.css';

const API_URL = window.location.origin + '/api';

const initialForm = {
  posicion: '',
  nombres_apellidos: '',
  documento_identidad: '',
  telefono: '',
  pais: '',
  correo_electronico: '',
  fecha_nacimiento: '',
  universidad: '',
  carrera: '',
  grado_academico: '',
  anios_experiencia: '',
  herramientas: '',
  expectativa_salarial: '',
  moneda: '',
  disponibilidad: '',
  nivel_ingles: '',
};

function App() {
  const [form, setForm] = useState(initialForm);
  const [cvFile, setCvFile] = useState(null);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [requerimientos, setRequerimientos] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/requerimientos`)
      .then(r => r.json())
      .then(data => setRequerimientos(Array.isArray(data) ? data.filter(r => r.estado !== 'Terminado' && r.estado !== 'Desestimado') : []))
      .catch(() => {});
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setCvFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      formData.append(key, value);
    });
    if (cvFile) {
      formData.append('cv', cvFile);
    }

    try {
      const res = await fetch(`${API_URL}/postulaciones`, {
        method: 'POST',
        body: formData,
      });
      const data = await res.json();
      if (res.ok) {
        setShowPopup(true);
        setForm(initialForm);
        setCvFile(null);
        const fileInput = document.getElementById('cv-input');
        if (fileInput) fileInput.value = '';
      } else {
        setMessage({ type: 'error', text: data.error || 'Error al enviar' });
      }
    } catch {
      setMessage({ type: 'error', text: 'Error de conexión con el servidor' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-container">
      <div className="logo-container">
        <img src="/logo.jpg" alt="Think4Good" className="logo" />
      </div>

      <h1 className="form-title">Formulario de postulación</h1>

      <div className="form-container">
        {message && (
          <div className={`message ${message.type}`}>{message.text}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Posición a la que postula:</label>
            <select
              name="posicion"
              value={form.posicion}
              onChange={handleChange}
              required
            >
              <option value="">— Seleccionar posición —</option>
              {requerimientos.map(r => (
                <option key={r.id} value={r.posicion}>{r.posicion}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Nombres y apellidos:</label>
            <input
              type="text"
              name="nombres_apellidos"
              value={form.nombres_apellidos}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>DNI - CE - RUT - OTROS:</label>
            <input
              type="text"
              name="documento_identidad"
              value={form.documento_identidad}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Teléfono:</label>
              <input
                type="tel"
                name="telefono"
                value={form.telefono}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>País:</label>
              <input
                type="text"
                name="pais"
                value={form.pais}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label>Correo Electrónico:</label>
            <input
              type="email"
              name="correo_electronico"
              value={form.correo_electronico}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Fecha de Nacimiento:</label>
            <input
              type="date"
              name="fecha_nacimiento"
              value={form.fecha_nacimiento}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>¿En qué universidad estudiaste?:</label>
            <input
              type="text"
              name="universidad"
              value={form.universidad}
              onChange={handleChange}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Carrera:</label>
              <input
                type="text"
                name="carrera"
                value={form.carrera}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Grado académico:</label>
              <input
                type="text"
                name="grado_academico"
                value={form.grado_academico}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label>Años de experiencia en el rol:</label>
            <input
              type="text"
              name="anios_experiencia"
              value={form.anios_experiencia}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Herramientas utilizadas por el rol:</label>
            <textarea
              name="herramientas"
              value={form.herramientas}
              onChange={handleChange}
              placeholder="Ej: Excel, SAP, Python, SQL..."
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Expectativa salarial:</label>
              <input
                type="text"
                name="expectativa_salarial"
                value={form.expectativa_salarial}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Moneda:</label>
              <input
                type="text"
                name="moneda"
                value={form.moneda}
                onChange={handleChange}
                placeholder="Ej: PEN, USD, CLP..."
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Disponibilidad:</label>
              <select
                name="disponibilidad"
                value={form.disponibilidad}
                onChange={handleChange}
              >
                <option value="">Seleccione...</option>
                <option value="Inmediata">Inmediata</option>
                <option value="15 días">15 días</option>
                <option value="30 días">30 días</option>
                <option value="Más de 30 días">Más de 30 días</option>
              </select>
            </div>
            <div className="form-group">
              <label>Nivel de inglés:</label>
              <select
                name="nivel_ingles"
                value={form.nivel_ingles}
                onChange={handleChange}
              >
                <option value="">Seleccione...</option>
                <option value="Básico">Básico</option>
                <option value="Intermedio">Intermedio</option>
                <option value="Avanzado">Avanzado</option>
                <option value="Nativo">Nativo</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Adjunta tu CV (PDF):</label>
            <div className="file-upload">
              <label className="file-upload-label" htmlFor="cv-input">
                Elegir archivo
              </label>
              <input
                id="cv-input"
                type="file"
                accept=".pdf"
                onChange={handleFileChange}
              />
              <span className="file-name">
                {cvFile ? cvFile.name : 'No se eligió ningún archivo'}
              </span>
            </div>
          </div>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar'}
          </button>
        </form>
      </div>

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Think4Good. Todos los derechos reservados.</p>
      </footer>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <div className="popup-icon">✓</div>
            <h2 className="popup-title">¡Postulación enviada!</h2>
            <p className="popup-text">Tu postulación fue registrada exitosamente. Nos pondremos en contacto contigo pronto.</p>
            <button className="popup-btn" onClick={() => setShowPopup(false)}>Aceptar</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
